module.exports = __webpack_public_path__ + "img/physical_vault.c63e81ea.svg";